export default {
	api: {
		epicClientID: 'b2155cc7-b75b-4b90-9f3b-f43ade2b3336',
		epicApi: 'https://ssproxy.osfhealthcare.org/dxp/',
		epicAccessToken: 'ZW1wJE9TRkRYUFBSRDpSZWoyITdqOVZ3NUg=',
		getDepartmentWaitTimes:
			'api/epic/2014/Scheduling/Utility/GetDepartmentWaitTimes/GetDepartmentWaitTimes',
		getScheduleDays:
			'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
		googleMapsUrl: 'https://www.google.com/maps/dir/',
		googleMapsMarkerUrl: '/images/map-marker-selected.png',
	},
	breakpoints: {
		xs: 0,
		sm: 375,
		md: 768,
		lg: 1280,
		xl: 1440,
		xxl: 1680,
	},
};
